export const countdownTimerColors = {
    COUNTDOWN_TIMER_GREEN: "#274D28",
    COUNTDOWN_TIMER_BG_GREEN: "#BAC6BA",
    COUNTDOWN_TIMER_RED: "#712D2B",
    COUNTDOWN_TIMER_BG_RED: "#D2BCBB",
}

export const countdownTimerUnits = {
    TENTH_SECOND_IN_MILLI: 100,
    ONE_SECOND_IN_MILLI: 1000,
    ONE_MINUTE_IN_MILLI: 60000,
}